module.exports = __webpack_public_path__ + "static/media/us_air_force.d08ecf31.png";